import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { SettingsLayout } from '../../components/Pleri/components/Settings/SettingsLayout';
import { ProtectedComponent } from '../../components/ProtectedComponent/ProtectedComponent';
import { useUserProfile } from '../../api/profile';
import { isPermitted } from '@plerionhq/design-system';

import { useTranslation } from 'react-i18next';

const ROI_REPORTS_PERMISSION = [
  'pleri:ReadOnly',
  'pleri:OrgUsage',
  'pleri:Write',
];

export const Route = createFileRoute('/settings/roi-reports')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('pleri/pages');
  const { data: userProfile } = useUserProfile();
  const permissions = userProfile?.permissions || [];
  const hasPermission = isPermitted(permissions, ROI_REPORTS_PERMISSION, false);

  return (
    <SettingsLayout>
      <ProtectedComponent permission={ROI_REPORTS_PERMISSION}>
        <Outlet />
      </ProtectedComponent>
      {!hasPermission && (
        <div className="flex h-full items-center justify-center p-8">
          <div className="text-center">
            <p className="text-lg font-medium text-gray-900 dark:text-gray-100">
              {t('accessDenied')}
            </p>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
              {t('youDonHavePermissionToAccessThis')}
            </p>
          </div>
        </div>
      )}
    </SettingsLayout>
  );
}
